import clinicCart from "./clinicCart";
import clinicDetails from "./clinicDetails";

export default{
    ...clinicCart,
    ...clinicDetails,
}